// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"758918fe","126":"f7f4f053","171":"393f3989","393":"194f0241","453":"e5b9b3e9","466":"6f7e8ff8","576":"e5c3598c","759":"3718e58d","780":"fb8c0c4d","968":"8f52b942"}[chunkId] + ".chunk.js";
};